import React, { Fragment } from 'react'
import { MainContext } from './State'
import { Icon, Grid, Button } from 'semantic-ui-react'

const YardsDowns = () => {
  return (
    <MainContext.Consumer>
      {({ onChange, firstDown, yardsLeft, down, quarter }) => (
        <Fragment>
          <Grid.Row>
            <Button circular color="blue" onClick={firstDown}>
              1st Down
            </Button>
          </Grid.Row>
          <Grid.Row columns="equal" divided color="green">
            <Grid.Column>
              <Grid.Row>
                <h4>Down:</h4>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <h2>{down}</h2>
                  </div>
                  <div>
                    <Icon
                      bordered
                      size="large"
                      name="plus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'down',
                            value: down >= 4 ? 1 : down + 1
                          }
                        })
                      }
                    />
                    <br />
                    <Icon
                      bordered
                      size="large"
                      name="minus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'down',
                            value: down <= 1 ? 4 : down - 1
                          }
                        })
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <h4>Goal:</h4>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <h2>{yardsLeft}</h2>
                  </div>
                  <div>
                    <Icon
                      bordered
                      size="large"
                      name="plus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'yardsLeft',
                            value: yardsLeft + 1
                          }
                        })
                      }
                    />
                    <br />
                    <Icon
                      bordered
                      size="large"
                      name="minus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'yardsLeft',
                            value: yardsLeft <= 1 ? 10 : yardsLeft - 1
                          }
                        })
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <h4>Quarter:</h4>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <h2>{quarter}</h2>
                  </div>
                  <div>
                    <Icon
                      bordered
                      size="large"
                      name="plus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'quarter',
                            value: quarter >= 4 ? 1 : quarter + 1
                          }
                        })
                      }
                    />
                    <br />
                    <Icon
                      bordered
                      size="large"
                      name="minus"
                      onClick={() =>
                        onChange({
                          target: {
                            name: 'quarter',
                            value: quarter <= 1 ? 4 : quarter - 1
                          }
                        })
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Fragment>
      )}
    </MainContext.Consumer>
  )
}

export default YardsDowns



// WEBPACK FOOTER //
// ./src/components/Controller/YardsDowns.jsx